import api from '@/lib/axios';
import { SocialMediaAccountDto } from '@/types';

/**
 * Get active social media accounts (public endpoint, no auth required)
 */
export const getActiveSocialMediaAccounts = async (): Promise<SocialMediaAccountDto[]> => {
    const response = await api.get<SocialMediaAccountDto[]>('/social-media-accounts/active');
    return response.data;
};
